import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import * as humanizeDuration from 'humanize-duration'
import {
  APARTMENT_MODULE_NAMESPACE,
  APARTMENT_GET_APPARTMENT,
  APARTMENT_ACTION,
  APARTMENT_EDIT_APARTMENT,
  APARTMENT_DELETE_APARTMENT,
  APARTMENT_RECORD_LOCATION_NUMBER,
  APARTMENT_GET_ZONE,
  APARTMENT_POST_ZONE, APARTMENT_PATCH_ZONE, APARTMENT_DELETE_ZONE
} from '../../../store/apartment';
import { IApartmentListingViewModel } from '../../../models/apartment';
import { CrudStatus } from '../../../common/enums';
import { Uris } from '../../../common/constants';
import {
  DOCUMENT_MODULE_NAMESPACE,
  DOCUMENT_SET_DOCUMENT_PARAMETER,
  DOCUMENT_GET_DOCUMENTS_ATTACHMENTS } from '../../../store/document';
import { IDocumentListingViewmodel, IDocumentParamter } from '../../../models/documents';
import { BLOCK_MODULE_NAMESPACE, BLOCK_SET_LOADER_STATE, BLOCK_LOADERS } from '../../../store/block';

const ApartmentStore = namespace(APARTMENT_MODULE_NAMESPACE)
const DocumentStore= namespace(DOCUMENT_MODULE_NAMESPACE)
const BlockStore= namespace(BLOCK_MODULE_NAMESPACE)

@Component({
  components: {
    'user-profile-widget': async () => import('@/components/user-profile-widget/UserProfileWidget.vue'),
    'user-profile-enhanced-widget': async () => import('@/components/user-profile-enhanced-widget/UserProfileEnhancedWidget.vue'),
    'block-infos-loader': async () => import('../loaders/block-infos-loader/BlockInfosLoader.vue'),
  },
  filters: {
    attachment_type(name: string){
      if(!name) return ''
      const res= name.split('.')
      if(res && res[1]) return res[1]
      return ''
    }
  }
})
class BlockApartmentsDetail extends Vue {

  _clearTimeout: any;
  dtCenter: { lat: number, lng: number };
  dtMarkerPosition: { lat: number | null, lng: number | null };
  dtStyle: any | null;
  dtActionOpen: boolean
  dtIsLoading: boolean
  dtMessageErrorModel: boolean;
  dtError: any;
  dtRecentDocuments: IDocumentListingViewmodel[]
  /**
   *
   */
  constructor() {
    super();
    this.dtStyle = null;
    this.dtCenter = {
      lat: 48.864716, lng: 2.349014
    }
    this.dtMarkerPosition = null;
    this.dtActionOpen= false
    this.dtIsLoading= false
    this.dtMessageErrorModel= false
    this.dtError= null
    this.dtRecentDocuments= []
    this.dtWriting = false;
    this.dtRecording = false;
    this.dtLocationNumber = null;
  }

  @ApartmentStore.Getter currentApartment: IApartmentListingViewModel;
  @ApartmentStore.Getter apartmentCrudActionStatus: CrudStatus
  @BlockStore.Getter loaders: Map<string,boolean>
  @BlockStore.Getter canManageDocuments: boolean
  /**
   * Store declarations
   */

  @ApartmentStore.Mutation(APARTMENT_ACTION)
  storeSetApartmentAction: (action: CrudStatus ) => void

  @ApartmentStore.Action(APARTMENT_EDIT_APARTMENT)
  storeEditApartment: () => void

  @ApartmentStore.Action(APARTMENT_GET_APPARTMENT)
  storeGetApartmentById: (payload: { blockId: string, apartmentId: string }) => Promise<IApartmentListingViewModel>;

  @ApartmentStore.Action(APARTMENT_DELETE_APARTMENT)
  storeDeleteApartment: () => Promise<any>

  @ApartmentStore.Action(APARTMENT_POST_ZONE)
  storePostApartmentZone: (payload) => Promise<any>

  @ApartmentStore.Action(APARTMENT_PATCH_ZONE)
  storePatchApartmentZone: (payload) => Promise<any>

  @ApartmentStore.Action(APARTMENT_DELETE_ZONE)
  storeDeleteApartmentZone: (payload) => Promise<any>

  @BlockStore.Mutation(BLOCK_SET_LOADER_STATE)
  storeSetBlockLoaderState: (payload?: { key: string, value: boolean }) => void
  @DocumentStore.Mutation(DOCUMENT_SET_DOCUMENT_PARAMETER)
  storeSetDocumentParameter: (documentParamter:IDocumentParamter) => void

  @DocumentStore.Action(DOCUMENT_GET_DOCUMENTS_ATTACHMENTS)
  storeGetDocuments: () => Promise<any>

  @BlockStore.Mutation(BLOCK_SET_LOADER_STATE)
  storeSetLoaderState: (payload?: { key: string, value: boolean }) => void

  @ApartmentStore.Action(APARTMENT_RECORD_LOCATION_NUMBER)
  storeSaveLocationNumber: (payload: { blockId: string, apartmentId: string, locationNumber: string }) => Promise<void>;

  dtWriting: boolean;
  dtRecording: boolean;
  dtLocationNumber: string;
  get lblSetting() {
    return {
      ...require('@/locales/block').default,
      ...require('@/locales/apartment').default,
      ...require('@/locales/button').default,
      ...require('@/locales/generic-labels').default
    }
  }
  get mapConfig() {
    return require('@/assets/json-resources/mapbox-config.json')
  }

  get coOwners() {
    return (this.currentApartment.owners || []).map(x => this.mapToResource(x).next().value);
  }
  get coTenants() {
    return (this.currentApartment.tenants || []).map(x => this.mapToResource(x).next().value);
  }
  get coCaretakers() {
    return (this.currentApartment.caretakers || []).map(x => this.mapToResource(x).next().value);
  }
  *mapToResource(x) {
    const avatar = `${(x.firstname || '').substring(0, 1)} ${(x.lastname || '').substring(0, 1)}`;
    yield {
      firstname: x.firstname,
      lastname: x.lastname,
      email: x.email,
      landline: x.landline,
      id: x.id,
      avatar: avatar.trim().replace(' ', '/')
    }
  }
  get coBlock() {
    return this.currentApartment.block || {};
  }

  get coAddress() {
    if (this.hasAddress)
      return this.aptAsBlock.address
    return this.coBlock!.address
  }

  get square_meter(){
    return (this.currentApartment as any)!.square_meter || '-'
  }

  get floor(){
    return (this.currentApartment as any)!.floor
  }

  get type () {
    return (this.currentApartment as any)!.type
  }

  get aptAsBlock () {
    return (this.currentApartment as any)!.apartment_as_block
  }

  get tenants(){
    return this.currentApartment && this.currentApartment.tenants ? this.currentApartment.tenants : null
  }

  get owners() {
    return this.currentApartment && this.currentApartment.owners ? this.currentApartment.owners: null
  }

  get favContacts() : any[] {
    return ((this.currentApartment as any)!.maintenance_referents || []).map(x => {
      x.role_name = 'Référent maintenance'
      return x
    })
      .concat(((this.currentApartment as any)!.vehicle_referents || []).map(x => {
        x.role_name = 'Référent véhicule'
        return x
      }))
      .map(contact => ({
        ...contact,
        fullname: contact.fullname || `${contact.firstname} ${contact.lastname}`.trim()
      }))
  }

  get favContactsIndexer() {
    return this.favContacts.map((contact,index) => index).filter(index => index % 2 === 0)
  }

  get floor_text() {
    if(!this.floor) return '-'
    const floor: number= parseInt(this.floor)
    switch (floor) {
      case 0:
        return this.$t(this.lblSetting.apartmentGroundFloor)
      case 1:
        return `1er ${this.$t(this.lblSetting.apartmentForm.floor)}`
      default:
        return `${floor}ème ${this.$t(this.lblSetting.apartmentForm.floor)}`
    }
  }

  get isOpenDeleteMessage() : boolean {
    return this.apartmentCrudActionStatus === CrudStatus.Delete
  }

  get coLoader(): boolean {
    return this.loaders.get(BLOCK_LOADERS.INFOS)
  }

  get coDocsLoader(): boolean {
    return this.loaders.get(BLOCK_LOADERS.DOCUMENTS)
  }
  get IsLouisianeEnv(){
    // console.log('is louisiane env',process.env.NODE_ENV)
    return process.env.NODE_ENV === 'prelouisiane' || process.env.NODE_ENV === 'louisiane'
  }
  get hasLocationNumber(): boolean {
    return !!this.currentApartment.location_number;
  }

  get isApartmentAsBlock(): boolean {
    return !!(this.currentApartment as any)!.apartment_as_block
  }

  get hasAddress ():boolean {
    return this.isApartmentAsBlock && !!this.aptAsBlock.address
  }

  get textConfigs () {
    return require('@/assets/json-resources/text-field-configs.json')
  }

  get wideDocsdisplay () {
    if (this.$route.meta['apartment_zone_allowed'] && this.isApartmentAsBlock) return true
    if (!this.$route.meta['apartment_zone_allowed'] && !this.isApartmentAsBlock) return true
    return false

  }

  mounted() {
    this.getApartmentById(this.$route.params.id, this.$route.params.cid)
    if(this.canManageDocuments) this.getDocumentsByApartmentId(this.$route.params.cid)
    this.$watch('$route.params', (value: { id: string, cid: string }) => {
      this.getApartmentById(value.id, value.cid)
      if(this.canManageDocuments) this.getDocumentsByApartmentId(value.cid)
    })
    this.initMapContainer()
    if (this.$route.path.indexOf('/apartment/') > -1) {
      window.onresize = () => this.initMapContainer();
    }
  }

  getDateDuration(creation: string){
    const duration: string= humanizeDuration(Date.now() - new Date(creation).getTime(), { language: this.$i18n.locale  })
    const durationMain= duration.split(',')[0]
    return durationMain
  }
  getDocumentsByApartmentId(apartmentId: string){
    this.storeSetDocumentParameter(
      {
        block: undefined,
        apartment: [parseInt(apartmentId)],
        detail: "list",
        orderKeys: ["createdAt"],
        orderValues: [-1],
        fk_attachment_type: [],
        $skip:0,
        $limit: 3
      })

    this.storeSetLoaderState({ key: BLOCK_LOADERS.DOCUMENTS, value: true })
    this.storeGetDocuments()
      .then(documents => {
         this.dtRecentDocuments= documents.data.slice(0,3).map(document => ({
           ...document,
           when: this.getDateDuration(document.createdAt)
         }))
         this.storeSetLoaderState({ key: BLOCK_LOADERS.DOCUMENTS, value: false })
      })
  }
  initMapContainer() {
    let intervalMapTracer: any;
    let isCleared: boolean;
    this.$nextTick(() => {
      isCleared = false;
      if (!isCleared) {
        intervalMapTracer = setInterval(() => {
          clearInterval(intervalMapTracer);
          let mainContainer = document.getElementsByClassName('main-container')[0];
          if (mainContainer) {
            let width: number = ((mainContainer.clientWidth - 500) / 4);
            this.dtStyle = {
              width: width + 'px !important',
              'min-width': width + 'px !important',
              'max-width': width + 'px !important',
              height: width + 'px  !important',
              'min-height': width + 'px  !important',
              'max-height': width + 'px  !important'
            }
          }
        }, 300)
      }
    })
  }
  getApartmentById(blockId: string, apartmentId: string) {
    this.storeSetBlockLoaderState({ key: BLOCK_LOADERS.INFOS, value: true })
    clearTimeout(this._clearTimeout)
    this._clearTimeout = setTimeout(() => {
      this.storeGetApartmentById({ blockId, apartmentId })
        .then((response: any) => {
          this.dtCenter = { lat: Number(this.coAddress.lat), lng: Number(this.coAddress.lng)}
          this.dtMarkerPosition = { lat: Number(this.coAddress.lat), lng: Number(this.coAddress.lng) }
        })
        .catch(error => console.log(error))
        .finally(() => this.storeSetBlockLoaderState({ key: BLOCK_LOADERS.INFOS, value: false }))
    }, 300);

  }

  handleEditApartment(){
    this.dtActionOpen= false
    this.storeEditApartment();
  }

  handleDeleteApartment(){
    this.storeSetApartmentAction(CrudStatus.Delete)
    this.dtActionOpen= false
  }

  handleDeleteCancel(){
    this.storeSetApartmentAction(CrudStatus.NoAction)
  }

  handleDeleteOK(){
    this.dtIsLoading= true
    this.storeDeleteApartment()
    .then(()=>{
      this.dtIsLoading= false
      this.$router.replace(`${Uris.BlockApartments.replace(':id',this.$route.params.id)}`)
    })
    .catch(err=>{
      this.dtMessageErrorModel= true
      this.dtError= err
    })
    .finally(()=>{
      this.dtActionOpen= false
    })
  }

  handleCloseErrorModal(){
    this.dtMessageErrorModel= false
    this.dtError= null
  }

  handleViewDocument(e:Event,link: string){
    e.preventDefault()
    if(link) window.open(link)
  }
  handleEditLocationNumber() {
    this.dtWriting = !this.dtWriting;
    setTimeout(() => {
      //@ts-ignore
      this.$refs.locationNumberRef.focus()
    }, 300);
    if (this.currentApartment.location_number) {
      this.dtLocationNumber = JSON.parse(JSON.stringify(this.currentApartment.location_number))
    }
  }
  handleRecordLocationNumber() {
    clearTimeout(this._clearTimeout)
    this._clearTimeout = setTimeout(() => {

      if (this.currentApartment.location_number === this.dtLocationNumber) {
        this.dtWriting = false;
        return;
      };

      this.dtRecording = true;

      this.storeSaveLocationNumber({
        blockId: this.$route.params.id,
        apartmentId: this.$route.params.cid,
        locationNumber: this.dtLocationNumber
      }).then(res => {
        this.dtWriting = false;
        this.dtLocationNumber = null;
        this.dtRecording = false;
      })
    }, 500);
  }
  handleLocationNumberOnBlur() {
    clearTimeout(this._clearTimeout)
    this._clearTimeout = setTimeout(() => {
      this.dtWriting = false;
    }, 300);
  }

  handleBeforeModalClose () {

  }

  goToZoneList() {
    this.$router.push({ path: this.$route.params.cid+'/zones' })
  }
}

export default BlockApartmentsDetail;



// WEBPACK FOOTER //
// ./src/containers/block/block-apartments-detail/index.ts